export default __webpack_public_path__ + "6e7b627bb0560d3b4fda61a92c941156.svg";